module.exports = __webpack_public_path__ + "img/specialeffects-2_cn.6ce7e50.jpg";